export const ADOBE_FONTS = '';
export const GOOGLE_FONTS = '';
export const NYC_API = 'a8202544c64440d6829ef77181a4bc66';